import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { ControllerFlowAPI, Experiments, IHttpClient } from '@wix/yoshi-flow-editor';

type IsOrderProvisionedResponse = {
  isProvisioned: boolean;
  hasGroup: boolean;
};

type ErrorHandler = ControllerFlowAPI['errorHandler'];

export class BenefitPrograms {
  constructor(private httpClient: IHttpClient, private experiments: Experiments, private errorHandler: ErrorHandler) {}

  public isInPopulation() {
    return this.experiments.enabled(TPA_EXPERIMENTS.BENEFIT_PROGRAMS_ENABLED);
  }

  public async isOrderProvisioned(orderId: string) {
    try {
      const response = await this.errorHandler.withErrorHandler(
        () =>
          this.httpClient.get<IsOrderProvisionedResponse>(
            `/_serverless/pricing-plans-bpp/is-order-provisioned/${orderId}`,
          ),
        { errorCodesMap: {} },
      );
      const { isProvisioned, hasGroup } = response.data;
      return isProvisioned && hasGroup;
    } catch (err) {
      this.errorHandler.getResolvedError(err);
      throw err;
    }
  }

  public async isEcomOrderProvisioned(orderId: string) {
    try {
      const response = await this.errorHandler.withErrorHandler(
        () =>
          this.httpClient.get<IsOrderProvisionedResponse>(
            `/_serverless/pricing-plans-bpp/is-ecom-order-provisioned/${orderId}`,
          ),
        { errorCodesMap: {} },
      );
      const { isProvisioned, hasGroup } = response.data;
      return isProvisioned && hasGroup;
    } catch (err) {
      this.errorHandler.getResolvedError(err);
      throw err;
    }
  }
}
